import { useState } from "react";
import ProductCard from "../components/ProductCard";
import "./Products.css";

const Products = ({ addToCart, products = [], loading = true }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortBy, setSortBy] = useState("popularity");

  if (loading) {
    return (
      <div className="products-page">
        <div className="loading-spinner">
          <p>Caricamento catalogo...</p>
        </div>
      </div>
    );
  }

  const categories = ["all", ...new Set(products.map((p) => p.category))];

  let filtered = products;

  if (selectedCategory !== "all") {
    filtered = filtered.filter((p) => p.category === selectedCategory);
  }

  if (sortBy === "price-low") {
    filtered = [...filtered].sort((a, b) => a.price - b.price);
  } else if (sortBy === "price-high") {
    filtered = [...filtered].sort((a, b) => b.price - a.price);
  } else if (sortBy === "rating") {
    filtered = [...filtered].sort((a, b) => b.reviews - a.reviews);
  }

  return (
    <div className="products-page">
      <div className="products-container">
        <aside className="products-sidebar">
          <div className="sidebar-section">
            <h3>Categorie</h3>
            <button
              className={`category-btn ${selectedCategory === "all" ? "active" : ""}`}
              onClick={() => setSelectedCategory("all")}
            >
              Tutti i Prodotti ({products.length})
            </button>
            {categories
              .filter((cat) => cat !== "all")
              .map((cat) => (
                <button
                  key={cat}
                  className={`category-btn ${selectedCategory === cat ? "active" : ""}`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat} ({products.filter((p) => p.category === cat).length})
                </button>
              ))}
          </div>

          <div className="sidebar-section">
            <h3>Filtri Prezzo</h3>
            <div className="price-filter">
              <input type="range" min="0" max="100" className="price-slider" />
              <p>€0 - €100</p>
            </div>
          </div>

          <div className="sidebar-section">
            <h3>Valutazione</h3>
            <label>
              <input type="checkbox" /> ★★★★★ 5 stelle
            </label>
            <label>
              <input type="checkbox" /> ★★★★ 4+ stelle
            </label>
            <label>
              <input type="checkbox" /> ★★★ 3+ stelle
            </label>
          </div>

          <div className="sidebar-section">
            <h3>Disponibilità</h3>
            <label>
              <input type="checkbox" defaultChecked /> In Stock
            </label>
            <label>
              <input type="checkbox" /> Fuori Stock
            </label>
          </div>
        </aside>

        <main className="products-main">
          <div className="products-header">
            <h1>Catalogo Pallet</h1>
            <div className="sort-controls">
              <label htmlFor="sort">Ordina per:</label>
              <select
                id="sort"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="sort-select"
              >
                <option value="popularity">Popolarità</option>
                <option value="price-low">Prezzo: Basso a Alto</option>
                <option value="price-high">Prezzo: Alto a Basso</option>
                <option value="rating">Valutazione più alta</option>
              </select>
            </div>
          </div>

          <div className="products-count">
            <p>{filtered.length} prodotti trovati</p>
          </div>

          <div className="products-grid">
            {filtered.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={addToCart}
              />
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="no-products">
              <p>Nessun prodotto trovato in questa categoria.</p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Products;
